import { push } from 'react-router-redux';
import { connect } from 'react-redux';

// constants
import { advancedScriptRequirements } from 'constants/advanced';

// actions
import { openLayerInclusionModal } from 'current/uiwidgets';
import { includeLayer, setHarvestCrop, setHarvestDate } from 'advanced';
import { startScriptFlow } from '../../script-flow';
import manualScriptFlowDefinition from 'manual/scriptFlowDefinition';

// selectors
import {
  getAdvancedScriptRequirementsMatch,
  getAvailableCciLayersWithCrops,
  getAvailableYieldLayersWithCrops,
  getHarvestHistoryParam,
  getExcludedLayersParam
} from 'advanced/selectors';
import { isAppMode as isAppModeFunc } from 'settings/selectors';
import { getCropList } from 'crops/selectors';
import { canViewYieldData as canViewYieldDataFunc } from 'product-features/selectors';
import ReviewHarvestHistory from './ReviewHarvestHistory';
// util
import {
  formatHistoryRowsForAvailableData,
  selectHarvestHistoryCropsAndDateFromCci
} from './harvestHistoryUtil';
import { getManualScriptingRoute } from 'util/routes';
import { buildUpgradeUrl } from 'util/urls';
import { FIELD_VIEW_URL } from 'constants/urls';

export default connect(
  (state) => {
    let historyRows = [];
    const advancedScriptRequirementsMatch = getAdvancedScriptRequirementsMatch(state);
    if (advancedScriptRequirementsMatch !== advancedScriptRequirements.DOES_NOT_MEET
      && advancedScriptRequirementsMatch !== advancedScriptRequirements.PENDING) {
      const cciLayers = getAvailableCciLayersWithCrops(state);
      const yieldLayers = getAvailableYieldLayersWithCrops(state);
      const harvestHistory = getHarvestHistoryParam(state); // User-selected crops for CCI rows.
      const excludedLayers = getExcludedLayersParam(state); // current running list of excluded layers
      const canViewYieldData = canViewYieldDataFunc(state);
      selectHarvestHistoryCropsAndDateFromCci(cciLayers, harvestHistory);
      historyRows = formatHistoryRowsForAvailableData({
        cciLayers, yieldLayers, harvestHistory, excludedLayers, canViewYieldData
      });
    }

    return {
      advancedScriptRequirementsMatch,
      cropList: getCropList(state),
      historyRows,
      isAppMode: isAppModeFunc(state),
      manualRoute: getManualScriptingRoute(state),
      upgradePath: buildUpgradeUrl(state)
    };
  },
  (dispatch) => {
    return {
      onClickImportLink: () => {
        window.location = FIELD_VIEW_URL.DATA_INBOX;
      },
      onClickManualScriptTrigger: ({ manualRoute }) => {
        dispatch(push(manualRoute));
        dispatch(startScriptFlow({ definition: manualScriptFlowDefinition }));
      },
      onSelectCropForSeason: ({ season, cropId }) => dispatch(setHarvestCrop({season, cropId})),
      onSelectDateForSeason: ({ season, date }) => dispatch(setHarvestDate({season, date})),
      onToggleLayerInclusion: ({ isIncluded, season, layerType, year, cropName }) => {
        // if layer has been excluded, we don't want to show the modal
        // if they're clicking the checkbox to INCLUDE it
        if (isIncluded) {
          dispatch(openLayerInclusionModal({ season, layerType, year, cropName }));
        } else {
          dispatch(includeLayer(season));
        }
      }
    };
  }
)(ReviewHarvestHistory);
